import { AnyObject } from 'final-form';
import React from 'react';
import { Form, FormRenderProps, FormProps } from 'react-final-form';

import { Sidebar } from './LayoutNext';

import type { SidebarProps } from './LayoutNext';

export type SidebarFormProps<T> = {
  children: (formProps: FormRenderProps<T>) => React.ReactNode;
  name?: string;
} & Pick<SidebarProps, 'onClose' | 'onExtend' | 'title' | 'testId' | 'className'> &
  FormProps<T>;

export const SidebarForm = <T extends AnyObject>({
  children,
  name,

  className,
  onClose,
  onExtend,
  testId,
  title,

  ...props
}: SidebarFormProps<T>): React.ReactElement<SidebarFormProps<T>> => (
  <Form<T> {...props}>
    {(formProps) => (
      <Sidebar
        as="form"
        className={className}
        name={name}
        onClose={onClose}
        onExtend={onExtend}
        onSubmit={formProps.handleSubmit}
        testId={testId}
        title={title}
      >
        {children(formProps)}
      </Sidebar>
    )}
  </Form>
);
